import { useIntl } from 'react-intl'

import { trackClientEvent } from 'analytics/analytics'
import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'

function RefreshSearchModal() {
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'rbYvIvLreEGlA63e23oj',
        defaultMessage: 'Your search session has expired',
      })}
      primaryActionText={intl.formatMessage({
        id: 'M8LKNactvVlY8PjnoDls',
        defaultMessage: 'Refresh',
      })}
      onPrimaryActionClick={() => {
        trackClientEvent({
          subject: 'expired',
          action: 'refresh',
          category: 'search',
          type: 'interaction',
        })
        window.location.reload()
      }}
    >
      <BodyText variant="large">
        {intl.formatMessage({
          id: 'LDEV7KxnCrcPprGK3AwW',
          defaultMessage: 'Refresh your search to see available offers.',
        })}
      </BodyText>
    </Modal>
  )
}

export default RefreshSearchModal
